import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import EpisodeSpotlight from "../components/EpisodeSpotlight";
import LiveBroadcast from "../components/LiveBroadcast";
import Pillars from "../components/Pillars";
import HostTeaser from "../components/HostTeaser";
import LiveMic from "../components/LiveMic";
import Episodes from "../components/Episodes";
import Videos from "../components/Videos";
import PhotoGallery from "../components/PhotoGallery";
import CitizenVoices from "../components/CitizenVoices";
import AskAssistant from "../components/AskAssistant";
import Subscribe from "../components/Subscribe";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-[#050B14] pb-20" data-testid="home-page">
      <Navbar />
      <Hero />
      <EpisodeSpotlight />
      <LiveBroadcast />
      <Pillars />
      <HostTeaser />
      <LiveMic />
      <Episodes />
      <Videos />
      <PhotoGallery />
      <CitizenVoices />
      <AskAssistant />
      <Subscribe />
      <Footer />
    </div>
  );
}
